const link = document.querySelector(".sizesGuide_link");
const modal = document.querySelector(".sizesGuide_modal_container");
const closeBtn = document.querySelector(".sizesGuide_modal .modal-close");
const header = document.querySelector(".site-control");

if (link) {
  link.addEventListener("click", (event) => {
    event.preventDefault();
    modal.classList.add("reveal");
    document.body.classList.add("noscroll");
  });

  closeBtn.addEventListener("click", (event) => {
    event.preventDefault();
    modal.classList.remove("reveal");
    document.body.classList.remove("noscroll");
  });

  header.addEventListener("click", (event) => {
    event.preventDefault();
    modal.classList.remove("reveal");
    document.body.classList.remove("noscroll");
  });
}
